"use client";

import { useEffect } from "react";
import { useImmer } from "use-immer";
import { useSearchParams } from "next/navigation";
import { MultiSelectFilter } from "@/forms/filters/multi-select-filter/multi-select-filter";
import { TextFilter } from "@/forms/filters/text-filter/text-filter";
import { createFilterModel } from "./model";

export const Filters = ({
  filtersSource = { specialization: {}, province: {} },
}: {
  filtersSource: ResidencyMapFilterSource;
}) => {
  const searchParams = useSearchParams();
  const [filters, setFilters] = useImmer(
    createFilterModel(filtersSource, searchParams),
  );

  useEffect(() => {
    const newFilters = createFilterModel(filtersSource, searchParams);
    setFilters(newFilters);
  }, [searchParams, filtersSource]);

  return (
    <div className={"@512:grid-cols-3 @512:gap-3 grid grid-cols-1 gap-2"}>
      <MultiSelectFilter filter={filters.specialization} faintIcons={true} />
      <MultiSelectFilter filter={filters.province} faintIcons={true} />
      <TextFilter filter={filters.q} />
    </div>
  );
};
